import { render, staticRenderFns } from "./suitGoods.vue?vue&type=template&id=71f6bd13&"
import script from "./suitGoods.vue?vue&type=script&lang=js&"
export * from "./suitGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports